import { decimalIn } from 'Helpers/currencyFormat';
import { ZERO_DASH } from 'Helpers/formatService';

export { ZERO_DASH };

export const STATUS_ALL = 'all';
export const STATUS_ACTIVE = 'active';
export const STATUS_CLOSED = 'closed';

export const STATUS_OPTIONS = [
    { value: STATUS_ALL, label: 'All' },
    { value: STATUS_ACTIVE, label: 'Active' },
    { value: STATUS_CLOSED, label: 'Closed' },
];

const MARGIN_BASIS_COST = 'cost';

/**
 * One line per column: the header (i) tip and the "How these figures are
 * calculated" list read the same text, so the two cannot drift apart.
 */
export function columnDefinitions(marginBasis) {
    return {
        budget: { label: 'Budget', text: 'Budgeted cost before mark-ups.' },
        markups: { label: 'Mark-ups', text: 'Mark-up and second category values applied to the budget.' },
        total: { label: 'Total', text: 'Budget plus mark-ups.' },
        margin: {
            label: 'Margin',
            text: marginBasis === MARGIN_BASIS_COST ? 'Mark-ups as a share of budget.' : 'Mark-ups as a share of total.',
        },
        revenue: { label: 'Revenue', text: 'Budgeted revenue for the project.' },
        committed: { label: 'Committed', text: 'Budget committed to date.' },
        actuals: { label: 'Actuals', text: 'Actual cost recorded to date.' },
        remaining: { label: 'Remaining', text: 'Budget less committed less actuals.' },
    };
}

const isBlank = (value) => value === null || value === undefined;

/**
 * Whole money in the project's own locale. A zero is shown as 0 rather than a
 * dash: a department with no mark-up has a mark-up of nothing, which is a
 * figure. A negative keeps a leading minus.
 */
export function formatMoney(value, locale = null) {
    if (isBlank(value)) {
        return ZERO_DASH;
    }

    const number = Number(value);
    const magnitude = decimalIn(locale, Math.abs(number), 0);

    return number < 0 && magnitude !== '0' ? `−${magnitude}` : magnitude;
}

/** A percentage to one decimal place, or a dash where there is nothing to divide by. */
export function formatPercent(value, locale = null) {
    if (isBlank(value)) {
        return ZERO_DASH;
    }

    return `${decimalIn(locale, Number(value), 1)}%`;
}

/** The row label for the total, naming its currency only when there is just one. */
export function totalLabel(report) {
    if (report.mixed_currency) {
        return { label: 'Total', suffix: '(mixed currencies)' };
    }

    return { label: 'Total', suffix: report.totals?.currency ? `(${report.totals.currency})` : '' };
}
